export class ReconModel {
    partner: string;
    bankdepositamt: number;
    date: number;
    arthcloudamount: number;
}
